<template>
  <div :class="isManutentionMain()">
    <div :class="isManutention()" v-if="sitemanutencao">
      <manutencao></manutencao>
    </div>
    <player v-if="showLetterAndVideo && !sitemanutencao"></player>
    <div id="app" v-if="!sitemanutencao" class="container">
      <loading :active.sync="isLoading"></loading>
      <!-- CABECALHO -->
      <header-comp v-if="showLetterAndVideo"></header-comp>

      <div v-if="!isLoading" v-for="item in hotsite_config">
        <component :is="item.bloco" v-if="item.bloco !='poll' && item.bloco != 'letter-video'">
        </component>
      </div>
      <!-- RODAPE -->
      <footer-comp v-if="showContentFooter"></footer-comp>
    </div>
  </div>
</template>

<script>
  import HelloWorld from './components/HelloWorld'
  import NextMusic from "./components/NextMusic";
  import PreviusMusic from "./components/PreviusMusic";
  import Chat from "./components/Chat";
  import RequestMusic from "./components/RequestMusic";
  import Message from "./components/Message";
  import Announcer from "./components/Announcer";
  import Programming from "./components/Programming";
  import HeaderComp from "./components/HeaderComp";
  import FooterComp from "./components/FooterComp";
  import services from './service/api'
  import $ from 'jquery';
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.min.css';
  import Player from "./components/Player";
  import {mapActions} from 'vuex'
  import Manutencao from "./components/Manutencao";

  export default {
    name: 'App',
    components: {
      Manutencao,
      Player,
      FooterComp,
      HeaderComp,
      Programming,
      Announcer,
      Message,
      RequestMusic,
      Chat,
      NextMusic,
      PreviusMusic,
      HelloWorld,
      Loading
    },
    data() {
      return {
        coponents: [],
        letter: null,
        video: null,
        hotsite_config: {},
        builder: {},
        urlcurrent: '',
        urlhistoric: '',
        urlupcoming: '',
        upcoming: '',
        historic: '',
        showLetterAndVideo: false,
        showLastAndNext: false,
        showMessages: false,
        showProgramming: false,
        programming: '',
        messages: '',
        announcers: '',
        showAnnouncers: '',
        showFooter: null,
        isLoading: true,
        sitemanutencao: null,
      }
    },
    mounted() {
    },
    created() {
      let self = this;
      services.getWithoutToken(window.config.API_URL + "builder/" + window.config.BUILDER_ID).then(function (response) {
        self.sitemanutencao = response.data.aparencia.builder.manutencao;

        //configuracoes de exibicao
        self.hotsite_config = response.data.aparencia.builder.hotsite_config;
        self.builderInfo(response.data)

        // window.config.HOTSITE = response.data.aparencia.builder.hotsite_config;
        self.builder = response.data;
        //configuracoes de exibicao
        let config = response.data.aparencia.builder.hotsite_config;
        config.forEach(function (value, key) {
          if (value.bloco == "poll" && value.show == true) {
            window.config.site.showPoll = value.show;
          }
          if (value.bloco == "request-music" && value.show == true) {
            window.config.site.showRequestMusic = value.show;
          }
          if (value.bloco == "next-music" && value.show == true) {
            window.config.site.showNextMusic = value.show;
          }
          if (value.bloco == "previus-music" && value.show == true) {
            window.config.site.showPreviusMusic = value.show;
          }
          if (value.bloco == "chat" && value.show == true) {
            window.config.site.chat = value.show;
          }
          if (value.bloco == "announcer" && value.show == true) {
            window.config.site.announcer = value.show;
          }
          if (value.bloco == "message" && value.show == true) {
            window.config.site.message = value.show;
          }
          if (value.bloco == "programming" && value.show == true) {
            window.config.site.programming = value.show;
          }
          if (value.bloco == "letter-video" && value.show == true) {
            window.config.site.letterVideo = value.show;
          }
        });

        window.config.site.site_title_name = response.data.aparencia.builder.site_title_name;

        //get urls
        window.config.urlhistoric = response.data.historic;
        window.config.urlupcoming = response.data.upcoming;
        window.config.urlcurrent = response.data.current;

        if (window.config.urlcurrent) {
          //se o response estiver online:false, radio indisponivel no momento
          services.getWithoutToken(window.config.urlcurrent).then(function (response) {
            // console.log( self.urlcurrent)
            self.currentInfo(response.data)
            self.showFooter++;
            //exibe componente
            self.showLetterAndVideo = true;

            // so exib ultimas e proximas se estiver no autodj
            if (response.data.mount === 'autodj') {
              services.getWithoutToken(window.config.urlupcoming).then(function (response) {
                window.config.upcoming = response.data.data;
                services.getWithoutToken(window.config.urlhistoric).then(function (response) {
                  window.config.historic = response.data.data;
                  self.isLoading = false;
                });
              });
            } else {
              self.isLoading = false;
            }
          });
        } else {
          self.showLetterAndVideo = true;
          self.showFooter++;
          self.isLoading = false;
        }

      });

      services.get('social-links/').then(function (response) {
        self.redeSocial(response.data.result);
        self.showFooter++;

      });
    },
    methods: {
      ...mapActions(['builderInfo', 'currentInfo', 'redeSocial']),
      isManutention() {
        if (this.sitemanutencao) {
          return "manutencao";
        }
      },
      isManutentionMain() {
        if (this.sitemanutencao) {
          return "manutencao-main";
        }
      },
    },
    computed: {
      showContentFooter() {
        if (this.showFooter >= 2) {
          return true;
        }
        return false;
      },
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue